import { AxiosResponse } from 'axios';
import { defaultTo, path, pipe } from 'ramda';

import { PoolMaintenance } from '../types';

export const getPoolMaintenanceTableDataConverter = pipe<
  [AxiosResponse<PoolMaintenance[]>],
  PoolMaintenance[] | undefined,
  PoolMaintenance[]
>(path(['data']), defaultTo([]));
